module.exports = __webpack_public_path__ + "distribution-logo-spotify.7e415c72d57e26624219610bf49ac85f.svg";